import React from "react";
import { FlexContainer } from "src/components";
import TextSizeAdjuster from "../components/TextSizeAdjuster";
import { TextLabel } from "../../style";

export const AdjustTextSizeField = ({ value, onChange }) => {

    return (
        <FlexContainer style={{ flexDirection: "column" }}>
            <TextLabel color="#000000" fontWeight="bold" fontSize="16px">
              Adjust Text Size
            </TextLabel>
            <TextLabel color="#612684" fontSize="15px">
              Drag to make your quote text bigger or smaller.
            </TextLabel>
            <TextSizeAdjuster min={10} max={30} value={value} onChange={(e) => onChange(e)}/>
        </FlexContainer>
    );
};
